import { inject } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { User } from 'app/shared/models/user';
import { AuthStateService } from './auth-state.service';

export abstract class ServiceBase {
  public readonly UrlServiceV1 = environment.urlApi;
  public readonly UrlServiceOauthV1 = environment.urlApi;
  private readonly environmentName = environment.environmentName;
  protected readonly subscriptionKey = environment.subscriptionKey;
  public readonly azureBlobStorage = environment.azureBlobStorage;
  public readonly agrirouterOnboardUrl = environment.agrirouterOnboardUrl;

  protected readonly authState = inject(AuthStateService);

  public obterUsuarioLogado(): User | null {
    return this.authState.getUser() ?? null;
  }

  public obterTokenUsuario(): string {
    return this.authState.getToken() ?? '';
  }

  public obterHeaderJson() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  public obterHeaderUrlencoded() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
    };
  }

  public obterAuthHeader() {
    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.obterTokenUsuario()}`,
        'Ocp-Apim-Subscription-Key': this.subscriptionKey,
      }),
    };
    if (this.environmentName === 'LOCAL') {
      const userData = JSON.stringify(this.authState.getUser()) ?? '';
      headers.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'app-user-data': userData,
      });
    }
    return headers;
  }

  public obterAuthHeaderForFileUpload() {
    const headers = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.obterTokenUsuario()}`,
        'Ocp-Apim-Subscription-Key': this.subscriptionKey,
      }),
    };
    if (this.environmentName === 'LOCAL') {
      const userData = JSON.stringify(this.authState.getUser()) ?? '';
      headers.headers = new HttpHeaders({
        'app-user-data': userData,
      });
    }
    return headers;
  }

  public extractData<T>(response: T): T | null {
    return response ?? null;
  }

  public serviceError(error: Response) {
    return observableThrowError(error);
  }
}
